import { useMemo } from 'react';

import { fromUTCToTimeZone } from '@gogame/intl-ts';
import { useScreenState } from '@gogame/screens';

import { useFiltersWithPeriodType } from 'scenes/Trackers/Tracker/hooks';

import {
  SCALE_MONTHLY,
  SCALE_MONTH_TO_DATE,
} from '../Actions/ChartSettings/constants';
import { useCanLoadBreakdownChart } from './useCanLoadBreakdownChart';
import { useCanLoadChart } from './useCanLoadChart';
import { useChartState } from './useChartState';

export const useChartPayload = () => {
  const screenState = useScreenState();
  const chartState = useChartState();
  const canLoadChart = useCanLoadChart();
  const canLoadBreakdownChart = useCanLoadBreakdownChart();
  const filtersCollectionWithPeriodType = useFiltersWithPeriodType(
    screenState.filtersCollection
  );

  const lazy = chartState.lazy && (canLoadChart || canLoadBreakdownChart);

  const chartPayload = useMemo(() => {
    let queryParams = { enabled: false };
    if (!lazy && (canLoadBreakdownChart || canLoadChart)) {
      queryParams = {
        enabled: screenState.ready || false,
        filtersCollection: filtersCollectionWithPeriodType,
        advancedFilters: screenState.advancedFilters,
        dimensionSearchQuery: screenState.dimensionSearchQuery,
        presentedRows: screenState.presentedRows,
        drillPath: screenState.drillPath,
        statuses: screenState.statuses,
        settings: chartState.settings,
        metrics: chartState.metrics,
      };
      if (queryParams.settings.scale === SCALE_MONTH_TO_DATE) {
        queryParams.settings = {
          ...queryParams.settings,
          scale: SCALE_MONTHLY,
          scaleFilterToDay: fromUTCToTimeZone(
            screenState.filtersCollection[0].period[1]
          ).getDate(),
        };
      }
      canLoadBreakdownChart &&
        (queryParams = {
          ...queryParams,
          tableSettings: screenState.tableSettings,
          breakdown: chartState.breakdown,
        });
    }
    return queryParams;
  }, [
    screenState.ready,
    canLoadBreakdownChart,
    lazy,
    canLoadChart,
    filtersCollectionWithPeriodType,
    screenState.advancedFilters,
    screenState.dimensionSearchQuery,
    screenState.drillPath,
    screenState.statuses,
    screenState.presentedRows,
    chartState.settings,
    chartState.metrics,
    screenState.tableSettings,
    chartState.breakdown,
  ]);
  return chartPayload;
};
